/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PresignCaptureMediaResponse
 */
export interface PresignCaptureMediaResponse {
    /**
     * 
     */
    uploadUrl: string;
    /**
     * 
     */
    s3Key: string;
}

/**
 * Check if a given object implements the PresignCaptureMediaResponse interface.
 */
export function instanceOfPresignCaptureMediaResponse(value: object): value is PresignCaptureMediaResponse {
    if ((!('uploadUrl' in (value as Record<string, any>)) && !('upload_url' in (value as Record<string, any>))) || ((value as Record<string, any>)['uploadUrl'] === undefined && (value as Record<string, any>)['upload_url'] === undefined)) return false;
    if ((!('s3Key' in (value as Record<string, any>)) && !('s3_key' in (value as Record<string, any>))) || ((value as Record<string, any>)['s3Key'] === undefined && (value as Record<string, any>)['s3_key'] === undefined)) return false;
    return true;
}

export function PresignCaptureMediaResponseFromJSON(json: any): PresignCaptureMediaResponse {
    return PresignCaptureMediaResponseFromJSONTyped(json, false);
}

export function PresignCaptureMediaResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PresignCaptureMediaResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'uploadUrl': json['upload_url'],
        's3Key': json['s3_key'],
    };
}

export function PresignCaptureMediaResponseToJSON(json: any): PresignCaptureMediaResponse {
    return PresignCaptureMediaResponseToJSONTyped(json, false);
}

export function PresignCaptureMediaResponseToJSONTyped(value?: PresignCaptureMediaResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'upload_url': value['uploadUrl'],
        's3_key': value['s3Key'],
    };
}

